// extracted by mini-css-extract-plugin
export default {"slice":"bsJDJC5jrxlbvgk8kay4"};